import type { Vehicle } from '../vehicles/types';
import { SpatialHash } from './spatialHash';

/**
 * Per-step spatial index of every vehicle (civilian, parked, police, player). Rebuilt once per fixed
 * step by the traffic system (order 240) and shared with pedestrians and police through the
 * `vehicleGrid` service. Query radii must add ~3 m to cover a vehicle's half length.
 */
export class VehicleGrid {
  private readonly hash = new SpatialHash<Vehicle>(12);
  /** Vehicles with the siren on, refreshed with the grid. */
  readonly sirens: Vehicle[] = [];
  private builtAtFrame = -1;

  rebuild(vehicles: readonly Vehicle[], frame: number): void {
    this.hash.clear();
    this.sirens.length = 0;
    for (let i = 0; i < vehicles.length; i++) {
      const v = vehicles[i] as Vehicle;
      if (!v.body.enabled) continue;
      this.hash.insert(v.pos.x, v.pos.z, v);
      if (v.siren && !v.destroyed) this.sirens.push(v);
    }
    this.builtAtFrame = frame;
  }

  get frame(): number {
    return this.builtAtFrame;
  }

  forEachNear(x: number, z: number, r: number, fn: (v: Vehicle) => void): void {
    this.hash.forEachNear(x, z, r, fn);
  }
}

declare module '../core/services' {
  interface ServiceMap {
    vehicleGrid: VehicleGrid;
  }
}
